<app-top-nav-registration [llttfPage]="llttfpage"></app-top-nav-registration>
<div class="h-30"></div>
<div class="container">
    <div class="content">
        <div class="facility-heading">
            It looks like you already have an account with us.
        </div>
        <div class="designatedFacilityForm">

        <span>
            This could be from a previous registration with either the BounceBack® program or the Living Life to the Full program.
            Please log in using your existing email address and password.
        </span>
        <br>
        <div class="form-buttons"></div>
            <a href="/bb-login" class="submit-form-button">Login</a>

         </div>
        </div>
    </div>
<app-footer></app-footer>
